import _ from 'lodash';
import styled from 'styled-components';

import { Text as TextLayouComponent } from '@playbookux/playbook-web-core';

const AvatarCircle = styled.div.attrs((props) => ({
  backgroundColor: props.color || _.sample(props.theme.color.avatarBackground),
  height: props.height,
  width: props.width,
}))`
  align-items: center;
  background-color: ${(props) => props.backgroundColor};
  border-radius: 20px;
  display: flex;
  height: ${(props) => props.height};
  justify-content: center;
  margin-left: 15px;
  width: ${(props) => props.width};
`;

const AvatarText = styled(TextLayouComponent)`
  font-size: 20px;
  font-weight: 400;
`;

export {
  AvatarCircle,
  AvatarText,
};
